import { gql } from '@efficiently/client-core-graphql-models';

/**
 * No variables: the project is read server-side from the caller's app context.
 *
 * A caller without `DesignChangeEdit` gets `[]` rather than an error — the permission is checked
 * inside the service rather than at the guard, precisely so this stays a value. The client therefore
 * has no permission branch to model, and no failure branch beyond an ordinary transport failure.
 */
export const DESIGN_CHANGE_GATED_PROJECT_FINISH_IDS = gql(`
	query DesignChangeGatedProjectFinishIds {
		designChangeGatedProjectFinishIds
	}
`);
